import React, { lazy, Suspense } from "react";

import Skeleton from "~/components/loaders/Skeleton";
import { isEmpty } from "lodash";

import useGlobalCtas from "~/hooks/utils/useGlobalCtas";

const CtaBar = lazy(() => import("~/components/CtaBar"));

const ProductCategoryCtaBar = ({ data }) => {
    const {
        parentCategory,
        wpProductCategory: { slug },
    } = data;

    const ctas = useGlobalCtas([slug, parentCategory?.slug]);

    if (isEmpty(ctas)) {
        return null;
    }

    return (
        <Suspense fallback={<Skeleton variant="block" />}>
            <CtaBar sections={ctas} />
        </Suspense>
    );
};

export default ProductCategoryCtaBar;
